export const NAME = "verification";

/**
 * Flag set when user presses the "Bank iD" button.
 *
 * When it is present in `SessionStorage`, the user is redirected to Bank iD login page and the flag is removed.
 * When the page is entered again when the flag is missing, the user is redirected to KYC selection page.
 *
 * This prevents endless switching between our "redirect-to-bank-id" page and Bank iD's login page
 * when Back button is pressed on Bank iD's screen (which does `history.back()`).
 */
export const DO_BANK_ID_REDIRECT = "do_redirect_to_bank_id";
